import _ from 'lodash';
import { AuthConfig } from './appConfig';

export const authorize = (feature, authorizationProvider, providerSetting={}) => {    
    let authFeatures = AuthConfig.ROLES_FEATURES_CONFIG;
    //Get auth config    
    if(_.isEmpty(authFeatures) || authorizationProvider === undefined)  {
        return feature ? feature.resource : null;
    }

    //Get authorized roles for a given feature
    let allowedRoles = authFeatures
        .filter((currentValue) => currentValue.features.includes(feature.name))
        .map( currentValue => currentValue.role);

    if(_.isEmpty(allowedRoles)) {
        return feature ? feature.resource : null;
    }

    //Add authorization for the feature
    return  authorizationProvider(allowedRoles, providerSetting.showNotAuthorized)(feature.resource);
}

export default authorize;

// --------------
// Example usage
//----------------
// import AccountSettings from './accountSettings/Page;
//
// export default  authorize({
//     name: 'AccountSettings',
//     resource: connect(mapStateToProps, mapDispatchersToProps)(AccountSettings)
//   }, AuthorizedResource, {
//     showNotAuthorized: true
//   });
//
